"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var agentStatus_styles_1 = require("./agentStatus.styles");
var statusIcon_1 = require("./status-icon/statusIcon");
var header_1 = require("../../common/header/header");
var logInOutDateTime_1 = require("../../common/log-in-out/logInOutDateTime");
var core_components_1 = require("@securityproducts/core-components");
var agentStatus_i18n_1 = require("./agentStatus.i18n");
var AgentStatusMap = {
    status: "agentStatus",
    agent: "agentName",
    lastLoggedIn: "loggedIn",
    lastLoggedOut: "loggedOut",
};
var agentStatusOrder = ["loggedout", "calling", "idle", "wrapup", "busy", "onphone", "ready"];
function AgentStatusRow(props) {
    var strings = core_components_1.useLocalisation(agentStatus_i18n_1.agentStatusTranslations, props.language);
    return (React.createElement("div", { className: agentStatus_styles_1.tableRow, "data-qa": "row", id: props.id },
        React.createElement("div", { className: agentStatus_styles_1.status, "data-qa": "status" },
            React.createElement("div", { className: agentStatus_styles_1.statusWrapper },
                React.createElement("div", { className: agentStatus_styles_1.icon },
                    React.createElement(statusIcon_1.StatusIcon, { status: props.status })),
                strings[props.status])),
        React.createElement("div", { className: agentStatus_styles_1.agent, "data-qa": "agent" }, props.agent),
        React.createElement("div", { className: agentStatus_styles_1.loggedInOut, "data-qa": "lastLoggedIn" },
            React.createElement(logInOutDateTime_1.LogInOutDateTime, { id: "last-logged-in", timestamp: props.lastLoggedIn, timezone: props.timezone, language: props.language, dateOptions: {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }, timeOptions: { hour: "2-digit", minute: "2-digit" } })),
        React.createElement("div", { className: agentStatus_styles_1.loggedInOut, "data-qa": "lastLoggedOut" },
            React.createElement(logInOutDateTime_1.LogInOutDateTime, { id: "last-logged-out", timestamp: props.lastLoggedOut, timezone: props.timezone, language: props.language, dateOptions: {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                }, timeOptions: { hour: "2-digit", minute: "2-digit" } }))));
}
function AgentStatusList(props) {
    var strings = core_components_1.useLocalisation(agentStatus_i18n_1.agentStatusTranslations, props.language);
    var _a = React.useState(props.forceSort
        ? props.forceSort
        : {
            field: "lastLoggedIn",
            direction: -1,
        }), sort = _a[0], setSort = _a[1];
    function sortByAgentName(a, b) {
        var aAgent = a.agent;
        var bAgent = b.agent;
        var filtered = filterUndefined(aAgent, bAgent);
        if (filtered !== null) {
            return filtered;
        }
        else {
            aAgent = aAgent.toLowerCase();
            bAgent = bAgent.toLowerCase();
            if (aAgent < bAgent) {
                if (sort.direction === -1) {
                    return 1;
                }
                return -1;
            }
            if (aAgent > bAgent) {
                if (sort.direction === -1) {
                    return -1;
                }
                return 1;
            }
            if (aAgent === bAgent) {
                return secondarySortByLastLoggedIn(a, b);
            }
        }
        return 0;
    }
    function secondarySortByAgentName(a, b) {
        var aAgent = a.agent;
        var bAgent = b.agent;
        var filtered = filterUndefined(aAgent, bAgent);
        if (filtered !== null) {
            return filtered;
        }
        else {
            aAgent = aAgent.toLowerCase();
            bAgent = bAgent.toLowerCase();
            if (aAgent < bAgent) {
                return -1;
            }
            if (aAgent > bAgent) {
                return 1;
            }
            if (aAgent === bAgent) {
                return 0;
            }
        }
        return 0;
    }
    function sortByAgentStatus(a, b) {
        var aStatusOrder = agentStatusOrder.indexOf(a.status);
        var bStatusOrder = agentStatusOrder.indexOf(b.status);
        if (aStatusOrder === bStatusOrder) {
            return secondarySortByAgentName(a, b);
        }
        else {
            if (sort.direction === -1) {
                return aStatusOrder - bStatusOrder;
            }
            else {
                return bStatusOrder - aStatusOrder;
            }
        }
    }
    function sortByLastLoggedIn(a, b) {
        var aLastLoggedIn = a.lastLoggedIn;
        var bLastLoggedIn = b.lastLoggedIn;
        if ((aLastLoggedIn === undefined && bLastLoggedIn === undefined) ||
            aLastLoggedIn === bLastLoggedIn) {
            return secondarySortByAgentName(a, b);
        }
        if (aLastLoggedIn == undefined) {
            return 1;
        }
        if (bLastLoggedIn === undefined) {
            return -1;
        }
        var aLastLoggedInDate = new Date(aLastLoggedIn.replace(" ", "T"));
        var bLastLoggedInDate = new Date(bLastLoggedIn.replace(" ", "T"));
        if (aLastLoggedInDate > bLastLoggedInDate) {
            return 1 * sort.direction;
        }
        else if (aLastLoggedInDate < bLastLoggedInDate) {
            return -1 * sort.direction;
        }
        else {
            return secondarySortByAgentName(a, b);
        }
    }
    function secondarySortByLastLoggedIn(a, b) {
        var aLastLoggedIn = a.lastLoggedIn;
        var bLastLoggedIn = b.lastLoggedIn;
        if ((aLastLoggedIn === undefined && bLastLoggedIn === undefined) ||
            aLastLoggedIn === bLastLoggedIn) {
            return secondarySortByAgentName(a, b);
        }
        if (aLastLoggedIn === undefined) {
            return 1;
        }
        if (bLastLoggedIn === undefined) {
            return -1;
        }
        var aLastLoggedInDate = new Date(aLastLoggedIn.replace(" ", "T"));
        var bLastLoggedInDate = new Date(bLastLoggedIn.replace(" ", "T"));
        if (aLastLoggedInDate > bLastLoggedInDate) {
            return -1;
        }
        else if (aLastLoggedInDate < bLastLoggedInDate) {
            return 1;
        }
        else {
            return 0;
        }
    }
    function sortByLastLoggedOut(a, b) {
        var aLastLoggedOut = a.lastLoggedOut;
        var bLastLoggedOut = b.lastLoggedOut;
        if ((aLastLoggedOut === undefined && bLastLoggedOut === undefined) ||
            aLastLoggedOut === bLastLoggedOut) {
            return secondarySortByAgentName(a, b);
        }
        if (aLastLoggedOut === undefined) {
            return 1;
        }
        if (bLastLoggedOut === undefined) {
            return -1;
        }
        var aLastLoggedOutDate = new Date(aLastLoggedOut.replace(" ", "T"));
        var bLastLoggedOutDate = new Date(bLastLoggedOut.replace(" ", "T"));
        if (aLastLoggedOutDate > bLastLoggedOutDate) {
            return 1 * sort.direction;
        }
        else {
            return -1 * sort.direction;
        }
    }
    function getSort(field) {
        switch (field) {
            case "status":
                return sortByAgentStatus;
            case "lastLoggedIn":
                return sortByLastLoggedIn;
            case "lastLoggedOut":
                return sortByLastLoggedOut;
            case "agent":
            default:
                return sortByAgentName;
        }
    }
    function changeSort(field) {
        setSort({
            field: field,
            direction: sort.field === field ? sort.direction * -1 : 1,
        });
        props.updateSort({
            field: AgentStatusMap[field],
            direction: sort.direction === 1 ? "ascending" : "descending",
        });
    }
    var sortFn = getSort(sort.field);
    return (React.createElement("div", { id: "agent-status-list", "data-qa": "agent-status-list" },
        React.createElement("div", { className: agentStatus_styles_1.container },
            React.createElement("div", { className: agentStatus_styles_1.heading }, strings.agentStatus)),
        React.createElement("div", { className: agentStatus_styles_1.table, id: "agent-status-list-content", "data-qa": "agent-status-list-content" },
            React.createElement(header_1.Header, { sort: changeSort, sorting: { field: sort.field, direction: sort.direction } },
                React.createElement(header_1.HeaderColumn, { id: "status-sort", className: agentStatus_styles_1.status, sortField: "status" }, strings.status),
                React.createElement(header_1.HeaderColumn, { id: "agent-sort", className: agentStatus_styles_1.agent, sortField: "agent" }, strings.agent),
                React.createElement(header_1.HeaderColumn, { id: "lastLoggedIn-sort", className: agentStatus_styles_1.loggedInOut, sortField: "lastLoggedIn", isTimeField: true }, strings.lastLoggedIn),
                React.createElement(header_1.HeaderColumn, { id: "lastLoggedOut-sort", className: agentStatus_styles_1.loggedInOut, sortField: "lastLoggedOut", isTimeField: true }, strings.lastLoggedOut)),
            props.agents
                ? props.agents
                    .sort(sortFn)
                    .map(function (agentRow) { return (React.createElement(AgentStatusRow, { id: agentRow.id, key: agentRow.id, status: agentRow.status, agent: agentRow.agent, lastLoggedIn: agentRow.lastLoggedIn, lastLoggedOut: agentRow.lastLoggedOut, timezone: props.ianaTimezone, language: props.language })); })
                : undefined)));
}
exports.AgentStatusList = AgentStatusList;
function filterUndefined(a, b) {
    if (a === undefined && b === undefined) {
        return 0;
    }
    if (a === undefined) {
        return 1;
    }
    if (b === undefined) {
        return -1;
    }
    return null;
}
